import { createFileRoute, redirect } from '@tanstack/react-router';
import { enterLanding } from '@/shared/auth/landing';
import { useAuthStore } from '@/shared/auth/store';

export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({ to: '/login' });
    }

    // The user's default page, which for almost every account is a legacy one.
    await enterLanding(useAuthStore.getState().user);
  },
  component: () => null,
});
